import { AxiosError } from 'axios';
import { useState } from 'react';

import { DriverOverviewDataInterface } from '../../../models/dashboard/companyInsight/driverOverviewData';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import { driverOverviewDataActions } from '../../../redux/slices/driverOverviewDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useDriverOverviewData = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const onDriverOverviewError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.response?.data?.message ??
        'Something went wrong while retrieving driver overview data',
    );
  };

  const onDriverOverviewSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<DriverOverviewDataInterface>) => {
    dispatch(driverOverviewDataActions.setDriverOverviewData(data));
  };

  const getDriverOverviewData = async () => {
    const url: HttpConfig = {
      url: `ba/v1/dashboard/metrics`,
      method: 'get',
    };

    return request(
      url,
      onDriverOverviewSuccess,
      setLoading,
      onDriverOverviewError,
    );
  };

  return { getDriverOverviewData, loading };
};

export default useDriverOverviewData;
